import React from 'react';

import styled from '@emotion/styled';

import { media } from '../../services/media';

export const GetDataBox: React.FC<{ style?: any }> = ({
    children,
    ...rest
}) => {
    return (
        <StyledGetDataBox className="GetDataBox" {...rest}>
            {children}
        </StyledGetDataBox>
    );
};

const StyledGetDataBox = styled.div`
    position: relative;
    color: white;
    background-color: #010050;
    max-width: 715px;
    margin: 0 auto;

    line-height: 1.5;
    font-size: 1.25em;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 30px 0;
    min-height: 300px;

    ${media.min('lg')} {
        min-height: 450px;
        font-size: 24px;
        padding: 60px 100px;
    }

    &__consent {
        a {
            font-family: inheirt;
            font-size: 17px;
        }
    }
`;

export const GetDataSmallBox: React.FC = ({ children, ...rest }) => {
    return (
        <StyledGetDataSmallBox className="GetDataSmallBox" {...rest}>
            {children}
        </StyledGetDataSmallBox>
    );
};

const StyledGetDataSmallBox = styled.div`
    ${(props) =>
        props.theme.version === 'formue' && `background-color: #0740ad`}

    color: #8c9ece;
    width: 100%;
    line-height: 1.5;

    height: 100%;
    position: absolute;
    bottom: 0;
    top: 100%;
    max-height: 80px;

    @include md {
        max-height: 220px;
        top: unset;
        max-width: 300px;
        right: -150px;
        bottom: 50px;
        padding: 30px 60px;
    }

    display: flex;
    justify-content: center;
    align-items: center;

    h2 {
        font-size: 20px;
        color: white;
    }

    p {
        font-size: 17px;
        margin: 0;
    }
`;
